import React from 'react';
import { TAG_DETAIL_PAGE_LAYOUT_TYPE } from '../../../../../../constants/service/app/tagConstants';
import TagPreviewItemHeader from '../../TagPreviewItemHeader';
import TagPreviewDetailPageBottom from '../TagPreviewDetailPageBottom';
import TagPreviewDetailPageGallery from '../TagPreviewDetailPageGallery';
import TagPreviewDetailPageFeed from '../TagPreviewDetailPageFeed';
import './TagPreviewDetailPageWrap.scss';

const TagPreviewDetailPageWrap = (props) => {
  const { tagName, tagViewInfo, tagDetailLayoutType, tagDetailPage, changeTagDetailLayoutType } = props;
  const { relatedTagList, itemList } = tagDetailPage;

  return (
    <div className="tag-preview-main-detail-page-wrap">
      {/* 태그 헤더*/}
      <TagPreviewItemHeader tagName={tagName} tagViewInfo={tagViewInfo} isFollowingButton={false} />

      {relatedTagList.length ? (
        <div className="related-tag-list">
          <div className="label">관련태그</div>
          <div className="tag-list">
            {relatedTagList.map((item) => (
              <div className="tag" key={item.id}>
                #{item.name}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {tagDetailLayoutType === TAG_DETAIL_PAGE_LAYOUT_TYPE.GALLERY ? (
        <TagPreviewDetailPageGallery itemList={itemList} />
      ) : (
        <TagPreviewDetailPageFeed itemList={itemList} />
      )}

      <TagPreviewDetailPageBottom
        tagDetailLayoutType={tagDetailLayoutType}
        changeTagDetailLayoutType={changeTagDetailLayoutType}
      />
    </div>
  );
};

export default TagPreviewDetailPageWrap;
